module.exports = __webpack_public_path__ + "static/img/p1-2-2.8d1a991.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-kv/img/p1-2-2.png
// module id = 2W9c
// module chunks = 0